/** Store inventory / receiving / PO line category options. */
export const INVENTORY_CATEGORIES = ['PART', 'TOOL', 'MATERIAL', 'CONSUMABLE', 'GSE'];

export const INVENTORY_CATEGORY_LABELS = {
  PART: 'Part',
  TOOL: 'Tool',
  MATERIAL: 'Material',
  CONSUMABLE: 'Consumable',
  GSE: 'GSE'
};

export function normalizeInventoryCategory(value) {
  const raw = String(value || '').trim().toUpperCase();
  return INVENTORY_CATEGORIES.includes(raw) ? raw : 'PART';
}

export function inventoryCategoryLabel(value) {
  const normalized = normalizeInventoryCategory(value);
  return INVENTORY_CATEGORY_LABELS[normalized] || normalized;
}
